import { DeviceType } from '@services/constants'
import { IElectricityMeter, useDevices } from '@services/device'
import { Select, SelectProps } from '@shared/Form/Select'
import React from 'react'

type Props = SelectProps & {
  onSelectElectricitymeter?: (val: IElectricityMeter) => void
  customOptions?: Array<{ value: number | string; displayName: string }>
}

const EelectricitymeterSelect = React.forwardRef<typeof Select, Props>(
  (
    { onSelectElectricitymeter, onChange, customOptions, ...props }: Props,
    ref
  ): any => {
    const { dataSource, isLoading, refetch } = useDevices({
      deviceType: DeviceType.ELECTRIC_METER,
      pageNum: 0,
      pageSize: 999,
    })

    const handleChange = (val: any, option: any) => {
      if (onSelectElectricitymeter) {
        const selected = dataSource?.content?.find((x: any) => x.id === val)
        onSelectElectricitymeter(selected as IElectricityMeter)
      }
      if (onChange) {
        onChange?.(val, option)
      }
    }

    return (
      <Select
        ref={ref as any}
        loading={isLoading}
        allowClear
        disabled={isLoading}
        onChange={handleChange}
        {...props}>
        {!isLoading && customOptions
          ? customOptions.map((option, idx) => (
              <Select.Option key={option.value} value={option.value}>
                {option.displayName}
              </Select.Option>
            ))
          : null}
        {dataSource?.content?.map((x: any, idx: number) => (
          <Select.Option key={idx} value={x.id}>
            {x.displayName}
          </Select.Option>
        ))}
      </Select>
    )
  }
)

export default EelectricitymeterSelect
